import EventEmitter from 'eventemitter3';
import * as PIXI from 'pixi.js';

export interface SelectEvent {
  index: number;
}

interface TextureDefine {
  normal: number;
  open: number;
  over: number;
  openover: number;
}

const texturePaths = [
  '/img/pulldown_button_off.png',
  '/img/pulldown_button_off_over.png',
  '/img/pulldown_button_on.png',
  '/img/pulldown_button_on_over.png',
  '/img/pulldown_item.png',
  '/img/pulldown_item_over.png',
];

const buttonTexture: TextureDefine = {
  normal: 0,
  open: 2,
  over: 1,
  openover: 3,
};

function getButtonTexture(open: boolean, over: boolean): number {
  if (open) {
    return over ? buttonTexture.openover : buttonTexture.open;
  }
  return over ? buttonTexture.over : buttonTexture.normal;
}

function rgb(r: number, g: number, b: number) {
  // eslint-disable-next-line no-bitwise
  return (r << 16) + (g << 8) + b;
}

export class PixiPulldown extends EventEmitter<{
  select: [SelectEvent];
}> {
  private contaier: PIXI.Container;
  private button: PIXI.Sprite;
  private items: PIXI.Sprite[];
  private sprites: PIXI.Texture[] = [];
  private isOpen = false;
  private values = ['5mm/sec', '10mm/sec', '20mm/sec'];
  private currentIndex = 2;
  private buttonText: PIXI.Text;

  constructor() {
    super();
    this.contaier = new PIXI.Container();

    texturePaths.forEach((v) => {
      this.sprites.push(PIXI.Texture.from(v));
    });

    this.button = new PIXI.Sprite(this.sprites[0]);
    this.contaier.addChild(this.button);

    this.items = [
      new PIXI.Sprite(this.sprites[4]),
      new PIXI.Sprite(this.sprites[4]),
      new PIXI.Sprite(this.sprites[4]),
    ];

    const textOption = new PIXI.TextStyle({
      fill: [rgb(99, 255, 255)],
      fontSize: 16,
    });
    this.items.forEach((v, i) => {
      v.visible = false;
      const text = new PIXI.Text(this.values[i], textOption);
      v.addChild(text);
      text.position = new PIXI.Point(5, 2);
      v.position = new PIXI.Point(0, 19 * (i + 1));
      v.interactive = true;
      v.buttonMode = true;
      v.on('pointerover', () => {
        // eslint-disable-next-line prefer-destructuring
        v.texture = this.sprites[5];
      });
      v.on('pointerout', () => {
        // eslint-disable-next-line prefer-destructuring
        v.texture = this.sprites[4];
      });
      v.on('pointerdown', () => {
        this.currentIndex = i;
        this.buttonText.text = this.values[this.currentIndex];
        this.items.forEach((item) => {
          item.visible = false;
          this.button.texture = this.sprites[getButtonTexture(false, false)];
        });
        this.isOpen = false;
        this.emit('select', { index: i });
      });
    });
    this.contaier.addChild(...this.items);

    this.buttonText = new PIXI.Text(this.values[this.currentIndex], textOption);
    this.buttonText.position = new PIXI.Point(5, 2);
    this.button.addChild(this.buttonText);

    this.button.interactive = true;
    this.button.buttonMode = true;
    this.button.on('pointerover', () => {
      this.button.texture = this.sprites[getButtonTexture(this.isOpen, true)];
    });
    this.button.on('pointerout', () => {
      this.button.texture = this.sprites[getButtonTexture(this.isOpen, false)];
    });
    this.button.on('pointerdown', () => {
      this.isOpen = !this.isOpen;
      this.button.texture = this.sprites[getButtonTexture(this.isOpen, true)];

      this.items.forEach((v) => {
        v.visible = this.isOpen;
      });
    });
  }

  public getContainer() {
    return this.contaier;
  }
}
